import React, {RefObject} from "react";
import {getTranslate, Translate, TranslateFunction} from "react-localize-redux";
import {connect} from "react-redux";
import "./ErrorPageUnauthorized.scss";
import StoreState from "../../interfaces/store/storeState";
import CommonView from "../CommonView/CommonView";

interface StateProps {
    translate: TranslateFunction
}

type Props = StateProps;

class ErrorPageUnauthorized extends React.Component<Props> {
    private static readonly translatePath: string = "pages.ErrorPage";

    private messageRef: RefObject<HTMLSpanElement> = React.createRef();

    constructor(props: Props) {
        super(props);

        this.focusMessage = this.focusMessage.bind(this);
    }

    /**
     * Skip link for error page
     *
     * @return {void}
     */
    focusMessage(): void {
        this.messageRef.current?.focus();
    }

    render() {
        const {translatePath}: typeof ErrorPageUnauthorized = ErrorPageUnauthorized;
        return (
            <CommonView className="df-error-page-403" focusMainContent={this.focusMessage}>
                <div className="df-error-403">
                    <div className="df-error-img-403"/>
                    <div className="df-error-text-403">
                        <p>
                            <Translate id={`${translatePath}.403.text`}/>
                        </p>
                        <p>
                            <Translate id={`${translatePath}.unauthorizedAccess.text`}/>
                        </p>
                        <p>
                            <Translate id={`${translatePath}.instruction.text`}/>
                        </p>
                    </div>
                </div>
            </CommonView>
        );
    }
}

function mapStateToProps(state: StoreState): StateProps {
    return {
        translate: getTranslate(state.localize),
    };
}

export default connect(mapStateToProps)(ErrorPageUnauthorized);
